var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSwitzerland = function SvgSwitzerland(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 1000,
    viewBox: "0 0 32 32",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#f00",
    height: 32,
    width: 32
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 6,
    width: 20,
    x: 6,
    y: 13
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 20,
    width: 6,
    x: 13,
    y: 6
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSwitzerland);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMDAiIGhlaWdodD0iMTAwMCIgdmlld0JveD0iMCAwIDMyIDMyIj48cmVjdCBmaWxsPSIjZjAwIiBoZWlnaHQ9IjMyIiB3aWR0aD0iMzIiLz48cmVjdCBmaWxsPSIjZmZmIiBoZWlnaHQ9IjYiIHdpZHRoPSIyMCIgeD0iNiIgeT0iMTMiLz48cmVjdCBmaWxsPSIjZmZmIiBoZWlnaHQ9IjIwIiB3aWR0aD0iNiIgeD0iMTMiIHk9IjYiLz48L3N2Zz4=";